"use client";
import { useEffect } from "react";
import { useGlobalLoading } from "./global-loading-context";
import { Loader } from "./index";

// To restore the old Lottie loader, see LottieLoader.tsx for reference

const LOADING_TIMEOUT_MS = 7000; // 7 seconds

export function GlobalLoadingModal() {
	const { isLoading, setLoading } = useGlobalLoading();

	// Auto-dismiss loader after timeout to prevent stuck loading states
	useEffect(() => {
		if (!isLoading) return;

		const timeoutId = setTimeout(() => {
			console.warn("Global loader timeout reached - forcing loader to close");
			setLoading(false);
		}, LOADING_TIMEOUT_MS);

		return () => clearTimeout(timeoutId);
	}, [isLoading, setLoading]);

	if (!isLoading) {
		return null;
	}

	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				pointerEvents: "none",
				zIndex: 99999,
			}}
		>
			{/* Era logo with animated gradient - centered without overlay */}
			<Loader size={128} />
		</div>
	);
}
